import { ComponentProps, useRef, useState } from 'react'

import { CalendarIcon } from '@radix-ui/react-icons'

import { DatePicker } from '~/components/data-input/DatePicker'
import { headerHeight } from '~/components/layout/Header'
import { formatDate } from '~/libs/date'

type FieldProps = {
  children: React.ReactNode
}
const Field = (props: FieldProps) => (
  <div className="mt-4 mb-2">{props.children}</div>
)

export const PhotoClipDatePicker: React.FC<{
  visitedDate: Date | null | undefined
  setVisitedDate: (date: Date | null) => void
  inputProps?: ComponentProps<'input'>
  containerProps?: ComponentProps<'div'>
}> = (props) => {
  const [isDatepickerOpen, setIsDatepickerOpen] = useState(false)
  const onOpenCalendarAnchor = useRef<HTMLDivElement | null>(null)
  return (
    <>
      <div ref={onOpenCalendarAnchor} {...props.containerProps}>
        <Field>
          <label className="text-sm font-bold">訪問日</label>
          <span className="ml-2 text-xs bg-[#AEAEAE] text-white px-2 py-1 rounded-md">
            任意
          </span>
        </Field>
        <div className="flex items-end space-x-3">
          <label
            className="relative w-full"
            onClick={() => {
              setIsDatepickerOpen((v) => {
                const newValue = !v
                if (newValue && onOpenCalendarAnchor.current) {
                  const anchorTop =
                    onOpenCalendarAnchor.current.getBoundingClientRect().top
                  const bodyTop = document.body.getBoundingClientRect().top
                  window.scrollTo({
                    top: anchorTop - bodyTop - parseInt(headerHeight) - 8,
                    behavior: 'smooth',
                  })
                }
                return newValue
              })
            }}
          >
            <input
              name="visitedDate"
              type="text"
              className={`px-4 border border-gray rounded text-sm h-[40px] active:border-gray outline-0 w-full`}
              readOnly
              onChange={() => {}}
              value={
                props.visitedDate
                  ? formatDate(
                      { msec: props.visitedDate.getTime() },
                      { omitCurrentYear: false }
                    )
                  : ''
              }
              {...props.inputProps}
            />
            <div className="absolute top-0 bottom-0 right-0">
              <div className="flex items-center h-full mr-4">
                <CalendarIcon className="fill-gray" />
              </div>
            </div>
          </label>
        </div>
        <p className="text-xs mt-1">※自分以外には年月のみ表示されます。</p>
      </div>

      {isDatepickerOpen && (
        <DatePicker
          date={props.visitedDate}
          setDate={props.setVisitedDate}
          setIsDatepickerOpen={setIsDatepickerOpen}
        />
      )}
    </>
  )
}
